import { call, put, takeEvery } from "redux-saga/effects";

import { ErrorEvents } from "@types-runway/state";

import { stripe } from "../../api";
import * as pricesActions from "./pricesActions";
import * as pricesSlice from "./pricesSlice";

function* requestCasePrice({ priceId }: pricesActions.RequestCasePrice) {
  yield put(pricesSlice.requestCasePriceFailure({}));
  yield put(pricesSlice.requestCasePricePending());
  try {
    const { data } = yield call(() =>
      stripe.stripePost("prices", {
        pricesIds: [priceId],
      })
    );
    yield put(pricesSlice.requestCasePriceSuccess(data));
  } catch (error) {
    const exception: any = error;
    const event = exception?.response?.status === 401 ? ErrorEvents.ACCESS_DENIED : undefined;
    const message =
      event || exception?.response?.statusText || exception?.message || "Unknown error.";
    yield put(pricesSlice.requestShippingPriceFailure({ event, message }));
  }
}

export default function* pricesSaga() {
  yield takeEvery(pricesActions.REQUEST_CASE_PRICE, requestCasePrice);
}
